import { useDeviceSize } from "hooks";
import { trackUAEvent, trackCustomEvent } from "utils/tracking";
import type { ReactNode } from "react";
import { Link } from "@chakra-ui/react";
import type { SbEditableComponentProps } from "types/storyblok";
import type { CardsContainerProps } from "./CardsContainer.d";
import { CardsDesktop, CardsMobile } from "./Cards";

const ANIMATED_CARD_EVENT_UA = ["clicked", "AHPlusAnimatedCard", "PricingPlan"] as const;
const ANIMATED_CARD_EVENT = { event: "cta_click", label: "pricing_plan", placement: "ahplus_animated_cards" } as const;

const AsLink = ({ children, cardsUrl }: { children: ReactNode; cardsUrl: string }) => {
  const handletrackEvents = () => {
    trackUAEvent(ANIMATED_CARD_EVENT_UA);
    trackCustomEvent(ANIMATED_CARD_EVENT);
  };

  return (
    <Link
      href={cardsUrl}
      display="block"
      rounded="lg"
      _hover={{ textDecoration: "none", borderColor: "danger.500" }}
      onClick={handletrackEvents}
      data-testid="we-solve-card"
      sx={{ svg: { h: 10, w: 10 } }}
    >
      {children}
    </Link>
  );
};

const CardsContainer = ({
  cards,
  cardsHeightDesktop,
  cardsUrl,
  sbEditable,
}: SbEditableComponentProps<CardsContainerProps>) => {
  const { isTabletOrDesktop } = useDeviceSize();

  return isTabletOrDesktop ? (
    cardsUrl ? (
      <AsLink cardsUrl={cardsUrl}>
        <CardsDesktop cards={cards} cardsHeightDesktop={cardsHeightDesktop} sbEditable={sbEditable} />
      </AsLink>
    ) : (
      <CardsDesktop cards={cards} cardsHeightDesktop={cardsHeightDesktop} sbEditable={sbEditable} />
    )
  ) : cardsUrl ? (
    <AsLink cardsUrl={cardsUrl}>
      <CardsMobile cards={cards} sbEditable={sbEditable} />
    </AsLink>
  ) : (
    <CardsMobile cards={cards} sbEditable={sbEditable} />
  );
};

export default CardsContainer;
